"use client";
import React, { useState } from 'react';
import { Toaster, toast } from 'sonner';


interface FormProps {
  type: String;
}
export default function Form({type}: FormProps) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e:any) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Replace with your API call or email sending logic
      const response = await fetch('/api/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ to: 'aswiftcanada@gmail.com', from: 'info@aswift.ca', subject: 'New Waitlist Signup', email , type: type }),

      });

      if (response.ok) {
        toast.success('Email sent successfully!');
      } else {
        throw new Error('Email not sent');
      }
    } catch (error) {
      toast.error('Failed to send email:');
    } finally {
      setLoading(false);
      setEmail(''); 
    }
  };

  return (
    <>
      <form className="flex items-center h-[55px] bg-white my-5 rounded-[10px]" onSubmit={handleSubmit}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Submit Email"
          className="w-full p-3 rounded-[10px] outline-none"
          required
        />
        <button
          type="submit"
          className={`bg-black w-full text-[14px] max-w-[130px] mx-2 text-white font-semibold rounded-[10px] h-[40px] transition ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
          disabled={loading}
        >
          {loading ? 'Loading...' : 'Join the waitlist'}
        </button>
      </form>

       {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-10 backdrop-blur z-50">
           <img src="/assets/spin.svg" />
        </div>
      )} 

      <Toaster position='top-right' />
      
      <style jsx>{`
        .loader {
          border: 8px solid #f3f3f3; /* Light grey */
          border-top: 8px solid #3498db; /* Blue */
          border-radius: 50%;
          width: 50px;
          height: 50px;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}
